import React from "react";
import { Box } from "@mui/material";
import _map from "lodash/map";
import Grid from "@mui/material/Grid";
import CheckIcon from "@mui/icons-material/Check";
import { formatFilePath } from "@/src/services/mediaObjects";
import DeleteIcon from "@mui/icons-material/DeleteForeverOutlined";
import multipleFileUploadStyle from "./multipleFileUploadStyle";
import SingleFileUpload from "./SingleFileUpload";
import _sortBy from "lodash/sortBy";
import { useMutation } from "@tanstack/react-query";
import { deleteResource } from "@/src/services/reactQuery/reactQueryService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { MediaObject } from "@/src/types/Entities/MediaObject/MediaObject";

export type MultipleFileUploadProps = {
  product: AbstractCase;
  fieldname: string;
  description: string;
  mediaObjectCollection: MediaObject[];
  fetchMediaObjects: () => void;
  electronicFileFolderPath?: string;
  disabled?: boolean;
};

const MultipleFileUpload = ({
  product,
  fieldname,
  description,
  mediaObjectCollection,
  fetchMediaObjects,
  electronicFileFolderPath,
  disabled,
}: MultipleFileUploadProps) => {
  const deleteMutation = useMutation({
    mutationFn: deleteResource,
  });

  const deleteMediaObject = async (mediaObject: MediaObject) => {
    await deleteMutation.mutateAsync({
      id: mediaObject.id,
      uri: "/media_objects",
    });
    fetchMediaObjects();
  };

  return (
    <>
      <Grid container>
        {_map(_sortBy(mediaObjectCollection, "id"), (mediaObject) => (
          <Grid key={mediaObject.id} sx={multipleFileUploadStyle.file} size={12}>
            <CheckIcon sx={multipleFileUploadStyle.icon} />
            <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
              {formatFilePath(mediaObject.originalName, 20)}
            </Box>
            <Box component="span" sx={{ display: { xs: "none", md: "inline" } }}>
              {mediaObject.originalName}
            </Box>
            <DeleteIcon onClick={() => deleteMediaObject(mediaObject)} sx={multipleFileUploadStyle.deleteIcon} />
          </Grid>
        ))}
      </Grid>
      <SingleFileUpload
        product={product}
        description={description}
        electronicFileFolderPath={electronicFileFolderPath}
        fieldname={fieldname}
        fetchMediaObjects={fetchMediaObjects}
        buttonText={mediaObjectCollection.length ? "Weitere Datei hochladen" : "Datei hochladen"}
        disabled={disabled}
      />
    </>
  );
};
export default MultipleFileUpload;
